export default __webpack_public_path__ + "static/media/Surgery SR-Logo-White.fc58a964.png";